import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/providers/common.service';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-hosted-configuration',
  templateUrl: './hosted-configuration.component.html',
  styleUrls: ['./hosted-configuration.component.scss']
})
export class HostedConfigurationComponent implements OnInit {

  constructor( private formBuilder: UntypedFormBuilder, private messageService: MessageService,private commonService: CommonService,private ngbModal: NgbModal,private router: Router) { }

  env = ['dev', 'uat'];
  tpn = '';
  envConfig = environment.environmentName;
  token = '';
  isSubmit = false;
  configuation: UntypedFormGroup;
  @ViewChild('addConfig') addConfig: ElementRef;
  modalReferenceForAddNote: NgbModalRef;

  ngOnInit(): void {
    this.configuation = this.configForm();
    console.log("Env", this.envConfig);
    this.autoConfig();
  }
  ngAfterViewInit() {
    this.modalReferenceForAddNote = this.ngbModal.open(this.addConfig, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false, size: 'lg', scrollable: true });
  }
  configForm(): UntypedFormGroup {
    return this.formBuilder.group({
      tpn: ["", [Validators.required,Validators.pattern('^[0-9]{12}$')]],
      // envConfig: ["", [Validators.required]],
      token: ["",[]],
    })
  }

  autoConfig(){
    // if(!isEmpty(envData)){
      this.commonService.getCommonHttpClientQueryParams(apiLinks.getEnv, {env: this.envConfig}).subscribe(
        (res) => {
          this.tpn = res.tpn;
          this.token = res.authToken;
      },
        (err) => {
        console.log(err);
      });
    // }
  }
  showAlert(data, alertType) {
    this.messageService.add({
      severity: alertType,
      summary: data.status,
      detail: data.message,
    });
  }

  reset(){
    this.tpn = '';
    this.token = '';
  }
  async onFormSubmit(){
    this.isSubmit = true;
    if(this.configuation.get('tpn').valid){
      let routeUrl = '';
      let paymentUrl = '';
      let redirectUrl = '';
      if(this.envConfig == 'dev'){
        routeUrl = environment.portalUrl + '/dev/demo-merchant';
        paymentUrl = 'https://denovosystem.tech/paymentapi/external-payment-transaction';
        redirectUrl = "/dev/demo-merchant";
      }else if(this.envConfig == 'uat'){
        routeUrl = environment.portalUrl + '/uat/demo-merchant';
        paymentUrl = 'https://ipospays.tech/paymentapi/external-payment-transaction';
        redirectUrl = "/uat/demo-merchant";
      }
      this.commonService.getCommonHttpClientQueryParams(apiLinks.updateEnv, {tpn: this.tpn, authToken: this.token, env: this.envConfig, routeUrl, paymentUrl}).subscribe(data => {
        console.log(data);
        this.showAlert({ status: "success", message: "Hosted Environment Configured Successfully" }, "success");
      }, error => {
        console.log(error);
        this.showAlert(error, "error");
      });
      await this.delay(2000);
      this.modalReferenceForAddNote.close();
      this.router.navigate([redirectUrl]).then(() => {
        window.location.reload();
      });
    }
  }
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
